import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/',
    name: 'Index',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Index.vue')
    }
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Index.vue')
    }
  },
  {
    path: '/register',
    name: 'Register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Register.vue')
    }
  },
  {
    path: '/course-index',
    name: 'CourseIndex',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/CourseIndex.vue')
    }
  },
  {
    path: '/reporte-avance',
    name: 'ReporteAvance',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ReporteAvance.vue')
    }
  },
  {
    path: '/home-teacher',
    name: 'HomeTeacher',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/HomeTeacher.vue')
    }
  },
  {
    path: '/admin-groups',
    name: 'AdminGroups',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AdminGroups.vue')
    }
  },
  {
    path: '/group-info',
    name: 'GroupInfo',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/GroupInfo.vue')
    }
  },
  {
    path: '/ebooks',
    name: 'Ebooks',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Ebooks.vue')
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ForgotPassword.vue')
    }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Projects.vue')
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Profile.vue')
    }
  },
]

const router = new VueRouter({
  routes
})

export default router
